import PageShell from "@/components/PageShell";
import AgendaTimeline from "@/components/home/AgendaTimeline";
import VoucherMarquee from "@/components/home/VoucherMarquee";

export default function AgendaPage() {
  return (
    <PageShell>
      <AgendaTimeline />
      <VoucherMarquee />
    </PageShell>
  );
}
